import { Instagram, MessageCircle, Globe, Headphones, CalendarCheck, ChevronRight, ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import hotelImg from "@/assets/hotel-dark.jpg";
import { WA_HOSPITALITY } from "@/lib/site";

const FLOW = [
    { icon: Instagram, label: "INSTAGRAM" },
    { icon: MessageCircle, label: "WHATSAPP" },
    { icon: Globe, label: "SITE" },
    { icon: Headphones, label: "ATENDIMENTO" },
    { icon: CalendarCheck, label: "RESERVA" },
];

const Hospitality = () => (
    <section
        id="hotelaria"
        data-testid="hospitality-section"
        className="relative py-24 sm:py-32 bg-[#0a0a0e] border-y border-line/60 overflow-hidden"
    >
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
                <div className="flex flex-col gap-8">
                    <SectionHeading
                        eyebrow="Hotelaria"
                        title={
                            <>
                                Hotelaria não vende apenas quartos.{" "}
                                <span className="text-gold-grad">
                                    Vende uma experiência antes mesmo da reserva.
                                </span>
                            </>
                        }
                        text="O hóspede começa a escolher seu hotel muito antes de chegar à recepção. Instagram, WhatsApp, site, avaliações e comunicação fazem parte dessa decisão."
                    />
                    <Reveal delay={0.2}>
                        <a
                            href={WA_HOSPITALITY}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="hospitality-cta"
                            className="btn-ghost inline-flex items-center justify-center gap-2 rounded-full border border-gold/50 px-7 py-4 text-sm font-semibold tracking-wide text-gold w-fit"
                        >
                            Quero melhorar a presença do meu hotel
                            <ArrowUpRight size={16} />
                        </a>
                    </Reveal>
                </div>

                <Reveal delay={0.1}>
                    <div
                        data-testid="hospitality-image"
                        className="relative overflow-hidden border border-line"
                        style={{ clipPath: "polygon(0 0, 100% 0, 100% 88%, 88% 100%, 0 100%)" }}
                    >
                        <img
                            src={hotelImg}
                            alt="Interior de hotelaria de padrão premium à noite"
                            className="w-full h-[340px] sm:h-[460px] object-cover"
                            style={{ filter: "saturate(0.72) contrast(1.06) brightness(0.9)" }}
                            loading="lazy"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#070709]/85 via-transparent to-[#070709]/25" />
                        <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_50%_at_70%_30%,rgba(212,175,55,0.10),transparent_70%)]" />
                        <div className="absolute bottom-5 left-5 right-5 flex items-center justify-between">
                            <span className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-ink/80">
                                A experiência começa no digital
                            </span>
                            <span className="w-8 h-px bg-gold/70" />
                        </div>
                        <span className="absolute top-4 left-4 w-6 h-6 border-t border-l border-gold/70" />
                        <span className="absolute bottom-4 right-4 w-6 h-6 border-b border-r border-gold/70" />
                    </div>
                </Reveal>
            </div>

            <Reveal delay={0.15}>
                <div data-testid="hospitality-flow" className="mt-16 sm:mt-20">
                    <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-ink3 mb-8 text-center">
                        A jornada do hóspede
                    </p>
                    <div className="flex flex-col lg:flex-row items-stretch gap-2 lg:gap-0">
                        {FLOW.map((step, i) => (
                            <div key={step.label} className="flex flex-col lg:flex-row items-center flex-1">
                                <div className="w-full lg:flex-1 flex items-center gap-4 rounded-xl border border-line bg-card px-5 py-4 lg:py-5 lg:justify-center">
                                    <step.icon size={18} strokeWidth={1.6} className="text-gold shrink-0" />
                                    <span className="font-mono2 text-[11px] sm:text-xs tracking-[0.2em] text-ink whitespace-nowrap">
                                        {step.label}
                                    </span>
                                </div>
                                {i < FLOW.length - 1 && (
                                    <>
                                        <ChevronRight
                                            size={16}
                                            className="hidden lg:block text-gold/60 shrink-0 rotate-90 lg:rotate-0"
                                        />
                                        <span className="lg:hidden h-4 w-px bg-gold/40" />
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);

export default Hospitality;
